import React, { useMemo } from 'react';
import FacetMultiSelectDropdown from 'components/FacetMultiSelectDropdown';

interface MultiselectFilterModel {
	name: string;
	path: string;
	buckets: Bucket[];
	searchPlaceholder: string;
	onChange?: any;
	id: string;
	groupName: string;
}

interface Bucket {
	term: string;
	selected?: boolean;
}

/** Main description for this component. */
const MultiselectFilter: React.FC<MultiselectFilterModel> = ({
	name,
	searchPlaceholder,
	path,
	buckets,
	onChange,
}) => {
	const filters = useMemo(
		() => [
			{
				name,
				path,
				buckets,
				searchPlaceholder,
				selectedBuckets: buckets.filter((bucket) => bucket.selected).length,
			},
		],
		[buckets, name, path, searchPlaceholder]
	);

	return (
		<FacetMultiSelectDropdown
			filters={filters as any}
			clearText="Rensa"
			expandText="Expandera"
			searchable={false}
			showChips={false}
			onChange={(nextFilters: any) => {
				const nextFilter = nextFilters?.[0];
				if (!nextFilter) {
					return;
				}

				onChange({
					name: nextFilter.name,
					path: nextFilter.path,
					buckets: nextFilter.buckets.filter(
						(bucket: Bucket) => bucket.selected
					),
				});
			}}
		/>
	);
};

export default MultiselectFilter;
